import { useState } from "react";
import { EINGEBAUT, logoQuelle, useErscheinungsbild, type Logoart } from "./erscheinungsbild";

/**
 * Ein Logo des Betriebs — hochgeladen (Einstellungen › Erscheinungsbild)
 * oder eingebaut. Läuft die signierte URL ab oder fehlt die Datei, springt
 * das Bild auf das eingebaute zurück, statt als leerer Rahmen dazustehen.
 */
export function LogoBild({ art, eingebaut, className, alt }: {
  art: Logoart;
  /** Die eingebaute Fassung, falls eine andere als die der Art gilt (Kopf ohne Leistungszeile). */
  eingebaut?: string;
  className?: string;
  alt: string;
}) {
  const bild = useErscheinungsbild();
  const rueckfall = eingebaut ?? EINGEBAUT[art];
  const quelle = logoQuelle(bild, art, rueckfall);
  const [kaputt, setzeKaputt] = useState<string | null>(null);
  const src = kaputt === quelle ? rueckfall : quelle;
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      aria-hidden={alt === "" ? true : undefined}
      onError={() => { if (src !== rueckfall) setzeKaputt(quelle); }}
    />
  );
}
